<app-left-side-nav></app-left-side-nav>
<app-header *ngIf="!isMobileDevice"></app-header>

<!-- ✅ Payment In Progress Screen -->
<ng-container *ngIf="isPaymentInProgress; else pageContent">
  <div class="center-wrapper">
    <div class="card">

      <img src="assets/images/payment-in-progress.png" alt="Payment In Progress" class="payment-image" />

      <div class="loader"></div>

      <h1>Payment in Progress</h1>

      <!-- ✅ Dynamic amount + order -->
      <h5>
        ₹{{ amount }}
      </h5>
      <div>
        Order ID: {{ transactionId }}
      </div>
      <p>
        We are still processing your payment.<br />
        You will be notified about success or retry<br />
        within the next 5 minutes.
      </p>
    </div>
  </div>
</ng-container>


<!-- ✅ Normal Page Content -->
<ng-template #pageContent>
  <!-- page content area start -->
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <div class="afterLoginPageContainer">
      <div class="container p-0">
        <div class="mainContent">
          <div class="ticket_summary px-3">
            <div class="py-3 d-flex justify-content-between align-items-center">
              <div class="backLink" (click)="goBack()">
                <i class="fa fa-angle-left me-3"></i> Buy Tickets
              </div>
            </div>

            <h5 class="orderDet font-weight-600 mb-3 mt-3 ms-3">Order details</h5>

            <div class="borderAll">
              <div class="log p-3 pb-0">
                <p class="font-weight-600 green">Ticket Summary</p>

                <div class="mt-4">
                  <div class="ticketType d-flex justify-content-between align-items-center mb-3"
                    *ngFor="let item of ticketDetails">
                    <span class="type" translate="no">
                      <img class="me-2" src="{{ ticketsImagesBeforeSelecteingc[item.code].color }}" />
                      {{ item.register_people_count }} X {{ item.name }}
                    </span>

                    <span class="dis_price">
                      <span class="str" translate="no">₹ {{ getTotalPrice(item) }}</span>
                    </span>

                    <span class="price font-weight-600" translate="no">₹{{ item.paid_amount }}</span>
                  </div>
                </div>
              </div>

              <div class="log totalPrice p-3 d-flex justify-content-between align-items-center">
                <span class="type font-weight-600">Total Amount</span>
                <span class="dis_price">
                  <span class="str" translate="no">₹{{ details?.total_amount }}</span>
                </span>
                <span class="price font-weight-600 green" translate="no">₹{{ details?.paid_amount }}</span>
              </div>

              <div *ngIf="loyaltyDiscount?.length !== 0"
                class="loyality p-3 d-flex justify-content-between align-items-center">
                <span class="type">Loyalty Discount</span>
                <span class="price font-weight-600" translate="no">
                  - ₹{{ loyaltyDiscount[0].discount_amount }}
                </span>
              </div>
            </div>

            <div class="amoutToPay px-3 py-4 d-flex justify-content-between align-items-center mb-2 pe-0">
              <span class="type font-weight-600">Amount to pay</span>
              <span class="subTotal d-flex justify-content-center pt-2 fw-bold green" translate="no">
                ₹{{ details?.paid_amount }}
              </span>
            </div>

            <div class="saveAmt text-center mt-0">
              <img class="me-2" src="/assets/images/saving.gif" />
              You are saving a total of <i class="fa fa-angle-double-right mx-1"></i>
              <span class="font-weight-600" translate="no">₹{{ details?.discount_amount }}</span>
            </div>

            <div class="space"></div>

            <div class="footer-btn">
              <div class="px-2 text-center input_check_box mt-1">
                <input type="checkbox" class="form-check-input" id="exampleCheck1" [(ngModel)]="termsAccepted"
                  (change)="toggleTermsAcceptance($event)" />
                <label class="form-check-label ms-2 me-2" for="exampleCheck1">
                  I accept the
                </label>
                <strong class="tc green" data-bs-toggle="modal" data-bs-target="#termCondModal">
                  Terms & Conditions
                </strong>
              </div>

              <div class="btn-wrapper">
                <button type="button" class="btn custom-btn-style font-weight-600" [disabled]="!termsAccepted"
                  (click)="confirmBooking()">
                  Make Payment
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </ng-template>

  <!-- Terms & Conditions -->
  <div class="modal fade" id="termCondModal" tabindex="-1" aria-labelledby="TicketInfoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-bottom modal-dialog-scrollable">
      <div class="modal-content">
        <div class="text-end">
          <button type="button" class="btn" data-bs-dismiss="modal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body pt-1">
          <!-- ✅ Your Terms content remains unchanged -->
          <!-- ... full Terms HTML ... -->
        </div>
      </div>
    </div>
  </div>
</ng-template>